"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalAxios = void 0;
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("./auth");
const internalAxios = axios_1.default.create({});
exports.internalAxios = internalAxios;
internalAxios.interceptors.request.use((config) => {
    const applicationKey = localStorage
        .getItem('application_id')
        ?.toLowerCase();
    config.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;
    config.headers['applicationKey'] = applicationKey;
    return config;
});
internalAxios.interceptors.response.use((res) => {
    return res;
}, async (err) => {
    const originalReq = err.config;
    if (err.response) {
        if (err.response.status === 401 && !originalReq._retry) {
            originalReq._retry = true;
            try {
                const accessToken = localStorage.getItem('accessToken');
                const refreshToken = localStorage.getItem('refreshToken');
                if (refreshToken && accessToken) {
                    await (0, auth_1.refresh)(refreshToken, accessToken);
                    originalReq.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;
                    return internalAxios(originalReq);
                }
                err.response.message = 'no refresh token available';
                return Promise.reject(err);
            }
            catch (error) {
                return Promise.reject(error);
            }
        }
    }
    return Promise.reject(err);
});
